var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_971_60683)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_971_60683",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_971_60683)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.81112 9.00395L12.9301 4.42295C14.0301 3.94595 17.7501 2.42295 17.7501 2.42295C17.7501 2.42295 19.4681 1.75595 19.3251 3.37795C19.2771 4.04495 18.8961 6.38495 18.5141 8.91095L17.3211 16.4029C17.3211 16.4029 17.2211 17.5029 16.4141 17.6919C15.5455 17.6783 14.7061 17.3761 14.0281 16.8329C13.8371 16.6899 10.4491 14.5419 9.20812 13.4919C9.08098 13.4071 8.97755 13.2912 8.90759 13.1553C8.83763 13.0194 8.80344 12.8679 8.80824 12.7151C8.81304 12.5623 8.85668 12.4133 8.93504 12.282C9.0134 12.1508 9.1239 12.0417 9.25612 11.9649C10.9559 10.4055 12.6266 8.81461 14.2671 7.19295C14.8401 6.61995 15.4121 5.28395 13.0261 6.90595L6.29712 11.4389C5.95266 11.5951 5.58014 11.6799 5.20203 11.6881C4.82392 11.6964 4.44806 11.6279 4.09712 11.4869C2.66612 11.058 0.997118 10.4869 0.997118 10.4869C0.997118 10.4869 -0.147882 9.77095 1.80812 9.00795L1.81112 9.00395Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_971_60683"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/icon-telegram.adb62ce05f1d0abf56110c8b23df8ff8.svg";
export { ForwardRef as ReactComponent };